import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import Quilleditor from "../../Quilleditor/Quilleditor";
import DatePicker from "../../DatePicker/datePicker";
import EditorInput from "../../Inputs/EditorInput";
import ResumeButton from "../../Buttons/ResumeButton/ResumeButton";
import DateEdit from "../../DatePickerNew/DatePicker";

function EducationItem(props) {
  const [t, i18n] = useTranslation("common");
  const [showDatePicker, setShowDatePicker] = useState(false);

  const handleDatePicker = (selected) => {
    setShowDatePicker(!showDatePicker);
  };

  return (
    <>
      <div className=" col-md-12">
        <div className="row">
          <div className="col-md-12 mb-3 mr-2">
            {!props.showPopup && (
              <img
                src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/trash.svg`}
                alt="trash"
                className="ml-1 delete_icon float-right"
                onClick={props.handleItemDelete}
              />
            )}
          </div>
          {/* {!props.showPopup &&
                    <div className="col-md-1">
                        <img
                        src="/images/acc-dropup.svg"
                        className="ml-2"
                        />
                    </div>
                    } */}
        </div>
      </div>
      <div className=" col-md-12">
        <div className="row">
          {props?.res?.showFields?.name && (
            <div className="col-md-6 mb-3">
              <EditorInput
                label={t(`${props.sectionId}.name`)}
                value={props.res.name}
                name="name"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
          )}
          {props?.res?.showFields?.publishingCompany && (
            <div className="col-md-6 mb-3">
              <EditorInput
                label={t(`${props.sectionId}.publishingCompany`)}
                value={props.res.publishingCompany}
                name="publishingCompany"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
          )}
          {props?.res?.showFields?.authors && (
            <div className="col-md-6 mb-3">
              <EditorInput
                label={t(`${props.sectionId}.authors`)}
                value={props.res.authors}
                name="authors"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
          )}
          {props?.res?.showFields?.company && (
            <div className="col-md-6 mb-3">
              <EditorInput
                label={t(`${props.sectionId}.company`)}
                value={props.res.company}
                name="company"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
          )}
          {props?.res?.showFields?.location && (
            <div className="col-md-6 mb-3">
              <EditorInput
                label={t(`${props.sectionId}.location`)}
                value={props.res.location}
                name="location"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
          )}
          {props?.res?.showFields?.organization && (
            <div className="col-md-6 mb-3">
              <EditorInput
                label={t(`${props.sectionId}.organization`)}
                value={props.res.organization}
                name="organization"
                autoComplete="off"
                className={`form-control  ${props.sectionId}focus${props.index}`}
                onChange={props.resumeHandler}
                onBlur={props.resumeUpdate}
              />
            </div>
          )}
          {props?.res?.showFields?.date && (
            <div className="col-md-6">
              <span className="basiceditor-date-label">Date</span>
              <p className="basic-education-date-section">
                <span
                  className="experience-from"
                  data-placeholder="From"
                  // style={{
                  //   fontFamily: styles.bodyFont,
                  //   fontSize: styles.bodyFontSize,
                  // }}
                  onClick={() => handleDatePicker("from")}
                >
                  {props &&
                  props.res &&
                  props.res.dateRange &&
                  props.res.dateRange.fromYear &&
                  props.res.dateRange.fromMonth
                    ? `${props.res.dateRange.fromMonth} / ${props.res.dateRange.fromYear}`
                    : props &&
                      props.res &&
                      props.res.dateRange &&
                      props.res.dateRange.fromYear &&
                      props.res.dateRange.fromYear
                    ? props.res.dateRange.fromYear
                    : ""}
                </span>{" "}
                -{" "}
                <span
                  data-placeholder="To"
                  // style={{
                  //   fontFamily: styles.bodyFont,
                  //   fontSize: styles.bodyFontSize,
                  // }}
                  onClick={() => handleDatePicker("to")}
                >
                  {props &&
                  props.res &&
                  props.res.dateRange &&
                  props.res.dateRange.isOnGoing
                    ? props &&
                      props.res &&
                      props.res.dateRange &&
                      props.res.dateRange.onGoingText != ""
                      ? props &&
                        props.res &&
                        props.res.dateRange &&
                        props.res.dateRange.onGoingText
                      : "Ongoing"
                    : props &&
                      props.res &&
                      props.res.dateRange &&
                      props.res.dateRange.toYear &&
                      props &&
                      props.res &&
                      props.res.dateRange &&
                      props.res.dateRange.toMonth
                    ? `${
                        props &&
                        props.res &&
                        props.res.dateRange &&
                        props.res.dateRange.toMonth
                      } / ${
                        props &&
                        props.res &&
                        props.res.dateRange &&
                        props.res.dateRange.toYear
                      }`
                    : props &&
                      props.res &&
                      props.res.dateRange &&
                      props.res.dateRange.toYear
                    ? props &&
                      props.res &&
                      props.res.dateRange &&
                      props.res.dateRange.toYear
                    : ""}
                </span>
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="col-md-12">
        <label>{t(`education.description`)}</label>
        <Quilleditor
          type="basic"
          theme={"snow"}
          inivalue={props?.res?.description?.replace(/\n|\r/g, "")}
          className={`${props.sectionId}focus${props.index}`}
          current={props.index}
          id={props.sectionId}
          sectionId={props.sectionId}
          placeholder="Whats the one thing that you want someone to remember to after reading your resume?"
          setvalue={props.handleEditorChange}
          onBlur={props.resumeUpdate}
        />
      </div>
      {showDatePicker && showDatePicker && (
        <>
          <DateEdit
            dateHandler={props.dateHandler}
            index={props.index}
            response={props.res}
            showDatePicker={showDatePicker}
            setShowDatePicker={setShowDatePicker}
            isSelectedFrom={props.isSelectedFrom}
            sectionId={props.sectionId}
          />
        </>
      )}
    </>
  );
}

export default EducationItem;
